module.exports = __webpack_public_path__ + "static/media/report-arrow-up.1603bc75.svg";